export enum MessageReceivedPlatform {
  INDEED = 'indeed',
  LINKEDIN_CLASSIC = 'linkedin_classic',
  LINKEDIN_RECRUITER = 'linkedin_recruiter',
}
